import { useEffect } from 'react';

const ResponsivePolicySheet = ({ isOpen, onClose, title, children, mobileOnlyFooterLabel = '' }) => {
  useEffect(() => {
    if (!isOpen) return undefined;

    const prevOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';

    const handleKeyDown = (e) => {
      if (e.key === 'Escape') {
        onClose();
      }
    };

    window.addEventListener('keydown', handleKeyDown);

    return () => {
      document.body.style.overflow = prevOverflow;
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <>
      <div
        className="fixed inset-0 z-40 bg-black/50"
        onClick={onClose}
        aria-hidden="true"
      />

      <div className="fixed inset-x-0 bottom-0 z-50 md:inset-0 md:flex md:items-center md:justify-center md:p-4">
        <div
          className="flex max-h-[88vh] w-full flex-col overflow-hidden rounded-t-[24px] bg-white shadow-2xl md:max-h-[90vh] md:max-w-[920px] md:rounded-[20px]"
          onClick={(e) => e.stopPropagation()}
          role="dialog"
          aria-modal="true"
          aria-label={title}
        >
          <div className="flex flex-shrink-0 items-center justify-between border-b border-[#E5E7EB] px-5 py-4 md:px-8 md:py-6">
            <div className="min-w-0 pr-4">
              <p className="text-[16px] font-[650] text-[#111827] md:text-[22px]">{title}</p>
              <p className="mt-1 text-[11px] text-[#6B7280] md:text-[13px]"></p>
            </div>
            <button
              type="button"
              onClick={onClose}
              className="inline-flex h-9 w-9 flex-shrink-0 items-center justify-center rounded-full text-[#6B7280] transition hover:bg-[#F3F4F6]"
              aria-label="닫기"
            >
              <svg
                className="h-5 w-5"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>
          </div>

          <div className="min-h-0 flex-1 overflow-y-auto px-4 py-5 md:px-8 md:py-8">{children}</div>

          {mobileOnlyFooterLabel ? (
            <div className="flex-shrink-0 border-t border-[#E5E7EB] px-4 py-4 md:hidden">
              <button
                type="button"
                onClick={onClose}
                className="w-full rounded-xl bg-[#16C1B1] px-4 py-3 text-[15px] font-[600] text-white"
              >
                {mobileOnlyFooterLabel}
              </button>
            </div>
          ) : null}
        </div>
      </div>
    </>
  );
};

export default ResponsivePolicySheet;
